import React from 'react';
import { SkeletonItem as SkeletonItemDI } from '@atlaskit/side-navigation';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useIntlV2 as useIntlDI } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { MenuItem as MenuItemDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import {
	matchPartialUrlPathname,
	matchUrlPathname,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import messages from '../messages.tsx';

type NotificationsMenuProps = {
	projectKey: string;
};
export const Notifications = ({ projectKey }: NotificationsMenuProps) => {
	const { formatMessage } = useIntlDI();
	const baseSettingsUrl = getNextgenSettingsUrl(SERVICE_DESK_PROJECT, projectKey);

	if (projectKey == null) return <SkeletonItemDI />;

	return (
		<>
			<MenuItemDI
				analytics={{ itemId: 'internal-notifications' }}
				selectedOn={matchUrlPathname()}
				href={`${baseSettingsUrl}/internal-notifications`}
			>
				{formatMessage(messages.internalNotifications)}
			</MenuItemDI>

			<MenuItemDI
				analytics={{ itemId: 'notifications' }}
				href={`${baseSettingsUrl}/customer-notifications`}
				selectedOn={matchPartialUrlPathname()}
			>
				{formatMessage(messages.customerNotifications)}
			</MenuItemDI>

			<MenuItemDI
				analytics={{ itemId: 'notification-email' }}
				selectedOn={matchUrlPathname()}
				href={`${baseSettingsUrl}/notification-email`}
			>
				{formatMessage(messages.notificationEmail)}
			</MenuItemDI>
		</>
	);
};
